export const firebaseConfig = {
    apiKey: "AIzaSyCFu7u8XyAHmy98QJjzoYxtcOBWpVR83ig",
    authDomain: "gauntlet.houseofpung.net",
    databaseURL: "https://robot-game-d0ccb-default-rtdb.firebaseio.com",
    projectId: "robot-game-d0ccb",
    storageBucket: "robot-game-d0ccb.appspot.com",
    messagingSenderId: "229549328463",
    appId: "1:229549328463:web:537f2679a84eac8a44023a",
    measurementId: "G-3HS28CRX5E"
};